module.exports = __webpack_public_path__ + "media/images/bg/blank-orange-89096de85c95e8c1da5d55097b77ea08.svg";